/**
 * Enum for report table fields
 * @readonly
 * @enum {Array}
 */
export const REPORT_TABLE_FIELDS = Object.freeze([
	{
		key: 'sku_id',
		label: 'SKU',
		class: 'sku-col th-mw-230',
		cellClass: 'sku-cel',
	},
	{
		key: 'product_name',
		label: 'Product Name',
		class: 'product-name-col th-mw-230',
		cellClass: 'product-name-cel',
	},
	{
		key: 'brand',
		label: 'Brand',
		class: 'brand-col th-mw-140',
		cellClass: 'brand-cel',
	},
	{
		key: 'availableStock',
		label: 'Available stock',
		class: 'available-stock-col',
		cellClass: 'available-stock-cel',
	},
	{
		key: 'onlineStock',
		label: 'Online stock',
		class: 'online-stock-col',
		cellClass: 'online-stock-cel',
	},
	{
		key: 'offlineStock',
		label: 'Offline stock',
		class: 'offline-stock-col',
		cellClass: 'offline-stock-cel',
	},
	{
		key: 'totalStock',
		label: 'Total stock',
		class: 'total-stock-col',
		cellClass: 'otal-stock-cel',
	},
	{
		key: 'reserved',
		label: 'Reserved',
		class: 'reserved-col',
		cellClass: 'reserved-cel',
	},
	{
		key: 'committed',
		label: 'Commited',
		class: 'committed-col',
		cellClass: 'committed-cel',
	},
	{
		key: 'categories',
		label: 'Category',
		class: 'categories-col th-mw-280',
		cellClass: 'categories-cel',
	},
	{
		key: 'status',
		label: 'Status',
		class: 'status-col th-mw-80',
		cellClass: 'status-cel',
	},
	{
		key: 'type',
		label: 'Type',
		class: 'type-col th-mw-80',
		cellClass: 'type-cel',
	},
	{
		key: 'eolStatus',
		label: 'EOL status',
		class: 'type-col th-mw-80',
		cellClass: 'type-cel',
	},
	{
		key: 'latest_committed_at',
		label: 'Last purchase date',
		class: 'latest-committed-col th-mw-180',
		cellClass: 'latest-committed-cel',
	},
]);

